module.exports = __webpack_public_path__ + "static/media/findContactsFormBackground.1235548b.svg";